import { useEffect, useState } from "react";
import Sidebar from "@/components/Sidebar";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import FeedbackWidget from "@/components/FeedbackWidget";
import NotificationsBell from "@/components/NotificationsBell";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { InstallAppPrompt } from "@/components/InstallAppPrompt";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Menu, Zap } from "lucide-react";

export default function DashboardLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia("(min-width: 1024px)").matches);
  const { pathname } = useLocation();

  useEffect(() => { setMenuOpen(false); }, [pathname]);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const on = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);

  return (
    <div className="flex min-h-screen bg-zinc-50">
      <Sidebar mobileOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <main className="flex-1 min-w-0 overflow-x-clip pb-20 lg:pb-0">
        <header
          className="lg:hidden sticky top-0 z-30 flex items-center gap-3 h-14 px-3 bg-zinc-950 text-white"
          data-testid="mobile-top-bar"
        >
          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            className="p-2 -ml-1 rounded-md hover:bg-zinc-800"
            data-testid="mobile-menu-btn"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <div className="w-7 h-7 rounded-md bg-[#FF5A00] flex items-center justify-center">
              <Zap className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-heading font-bold">LeadForge</span>
          </div>
          {!isDesktop && <div className="bg-white rounded-lg text-zinc-900"><NotificationsBell /></div>}
        </header>
        <ImpersonationBanner />
        {isDesktop && (
          <div className="fixed top-3 right-4 z-20">
            <NotificationsBell />
          </div>
        )}
        <Outlet />
      </main>
      <MobileBottomNav onMore={() => setMenuOpen(true)} />
      {!isDesktop && <InstallAppPrompt />}
      <FeedbackWidget />
      <Toaster position="top-right" richColors />
    </div>
  );
}
